export enum CoachingPlanProgress {
  CompletedOngoing = 'Completed - Ongoing',
  CompletedFinished = 'Completed - Finished',
  InProgress = 'In progress',
  NotCompleted = 'Not completed',
}
